import * as yup from 'yup';

import {
  UnitPlanPromptNames,
  UP_PAGE_CHAR_LIMIT,
} from '@lessonPlanner/constants';

export default yup.object().shape({
  gradeLevel: yup.string().required('Please select a grade level'),
  subject: yup
    .string()
    .required('Please enter a subject')
    .test(
      'len',
      'You have reached the character limit',
      (val: any) => val.length <= UP_PAGE_CHAR_LIMIT,
    ),
  topic: yup.string().required('Please enter a topic'),
  format: yup
    .string()
    .required('Please select a curriculum')
    .oneOf(Object.values(UnitPlanPromptNames), 'Please select a curriculum'),
  theme: yup.string().nullable(),
  context: yup.string().nullable(),
  attributes: yup
    .array()
    .of(yup.string())
    .nullable()
    .max(3, 'You can select up to 3 attributes')
    .transform((value) => (value?.length ? value : undefined)),
  goals: yup.string().nullable(),
});
